"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function NosForfaitsPremium() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224297" id="catering-packages" ref={sectionRef} className="bg-background text-foreground py-24 px-4 relative overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-secondary/20 blur-[120px] rounded-full opacity-40" />
        <div className="absolute bottom-0 right-0 w-[600px] h-[400px] bg-primary/10 blur-[100px] rounded-full opacity-20" />
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className={`text-center max-w-3xl mx-auto mb-16 transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="font-serif text-4xl md:text-6xl font-bold mb-6 tracking-wider uppercase">
            Catering <span className="text-transparent bg-clip-text bg-gradient-to-r from-secondary to-primary">Packages</span>
          </h2>
          <p className="text-muted-foreground text-lg font-default">
            Bring the bold flavors of Sultani Grill & Burgers to your next event. From corporate lunches to royal weddings, we feed your crowd right.
          </p>
        </div>

        <div className={`text-center transition-all duration-1000 delay-300 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <p className="text-xl md:text-2xl font-serif tracking-widest text-primary uppercase">
            Prices coming soon, but you can call us for more information.
          </p>
          <div className="mt-8 h-px w-24 bg-gradient-to-r from-transparent via-primary to-transparent mx-auto" />
        </div>
      </div>
    </section>;
}